import React from "react";
var __jsx = React.createElement;
import { ReportComposerBody } from "./report-composer-body";
import { NoteComposerBody } from "./note-composer-body";
import { FormComposerBody } from "./form-composer-body";
import { FormViewerComposerBody } from "./form-viewer-composer-body";
import { LetterComposerBody } from "./letter-composer-body";
import { LetterViewerComposerBody } from "./letter-viewer-composer-body";
import { AttachmentComposerBody } from "./attachment-composer-body";
import { GenericComposerBody } from "./generic-composer-body";
import { SmsComposerBody } from "@/components/sms-composer";
/** Renders the open composer using the SDS modal shell, dispatched by type. */
export function ComposerModal(_ref) {
  var composer = _ref.composer;
  if (composer.type === "report") return /*#__PURE__*/React.createElement(ReportComposerBody, {
    composer: composer
  });
  if (composer.type === "note") return /*#__PURE__*/React.createElement(NoteComposerBody, {
    composer: composer
  });
  if (composer.type === "sms") return /*#__PURE__*/React.createElement(SmsComposerBody, {
    composer: composer
  });
  if (composer.type === "form") return /*#__PURE__*/React.createElement(FormComposerBody, {
    composer: composer
  });
  if (composer.type === "form-view") return /*#__PURE__*/React.createElement(FormViewerComposerBody, {
    composer: composer
  });
  if (composer.type === "letter") return /*#__PURE__*/React.createElement(LetterComposerBody, {
    composer: composer
  });
  if (composer.type === "letter-view") return /*#__PURE__*/React.createElement(LetterViewerComposerBody, {
    composer: composer
  });
  if (composer.type === "attachment") return /*#__PURE__*/React.createElement(AttachmentComposerBody, {
    composer: composer
  });
  return /*#__PURE__*/React.createElement(GenericComposerBody, {
    composer: composer
  });
}